import { ContextVariableTypes } from 'src/utils/enums';

export const ACCEPTABLE_CV_TYPES: (keyof typeof ContextVariableTypes)[] = [
  'SHORT_TEXT',
  'LONG_TEXT',
  'CHECKBOX',
  'NUMBER',
  'EMAIL',
  'PHONE',
  'DATE',
  'FLAT_LIST',
  'MULTI_SELECT_LIST',
  'LIST',
];

export const SUPPORTED_TOOL_TYPES = new Set([
  'demo',
  'api_call',
  'template_api_call',
  'system_built_in',
  'mcp',
  'open_side_conversation',
  'browser_agent',
  'zendesk_flowstate_action',
]);
